<template>
  <div class="highlights">
    <div
      v-if="highlightsTitle || highlightsDescription"
      class="highlights-intro"
    >
      <h2
        v-if="highlightsTitle"
      >
        {{ highlightsTitle }}
      </h2>
      <p v-if="highlightsDescription">
        {{ highlightsDescription }}
      </p>
    </div>
    <ul class="highlights-list">
      <li
        v-for="(highlight, i) in highlights"
        :key="i"
        class="highlights-list-item"
      >
        <img
          v-if="highlight.image"
          class="highlights-list-image"
          :src="highlight.image"
          alt=""
        >
        <h3
          v-if="highlight.title"
          class="highlights-list-title h4"
        >
          {{ highlight.title }}
        </h3>
        <p
          v-if="highlight.description"
          class="highlights-list-description"
        >
          {{ highlight.description }}
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'KfHighlightsList',
  props: {
    highlightsTitle: {
      type: String,
      default: '',
    },
    highlightsDescription: {
      type: String,
      default: '',
    },
    highlights: {
      type: Array,
      default: null,
    },
    btnAlignmentHorizontal: {
      type: Boolean,
      default: false,
    }
  },
};
</script>

<style lang="postcss">
.highlights {

  &-intro {
    @apply text-center mb-5;

    @screen md {
      @apply mb-12;
    }

    *:last-child {
      @apply mb-0;
    }
  }

  &-list {
    @apply flex flex-wrap justify-center gap-12;

    &-item {
      @apply flex flex-col items-center justify-start;
      width: 320px;
    }

    &-image {
      @apply mb-7 w-32 h-32;
    }

    &-title {
      @apply mb-2 text-black text-center;
    }

    &-description {
      @apply text-center text-base;
    }
  }


}
</style>

